import { InputBase, Stack, TextField, styled } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import palette from '../theme/palette';

export const InputContainer = styled(Stack)(() => ({
  alignItems: 'center',
  borderRadius: '0.4rem',
  padding: '0.2rem 0.4rem',
  backgroundColor: palette.visitor.input.bg,
}));

export const StyledInput = styled(InputBase)(() => ({
  opacity: 0.9,
  fontWeight: 400,
  fontFamily: 'sans-serif',
  flexGrow: 1,
  backgroundColor: '#d3d3d3',
  color: '#000',
  borderRadius: '10px',
  padding: '8.5px 13px',
  input: {
    '&::placeholder': {
      opacity: 0.9,
      color: palette.visitor.input.placeholder,
    },
  },
}));

export const StyledTextField = styled(TextField)(() => ({
  // fontSize: '0.8rem',
  // fontWeight: 900,
  fontFamily: 'sans-serif',
  flexGrow: 1,
  color: palette.visitor.input.color,
  border: 'none',
  input: {
    fontSize: '0.8rem',
    fontWeight: 900,
    '&::placeholder': {
      opacity: 0.9,
      color: palette.visitor.input.placeholder,
      fontWeight: 900,
      fontSize: '0.8rem',
    },
  },
}));

export const ThemeButton = styled(LoadingButton)(() => ({
  width: '100%',
  marginBottom: 8,
  border: '1px solid #ffce30',
  backgroundColor: '#d4af37',
  color: '#fff',
  fontWeight: 500,
  '&:disabled': {
    filter: 'grayscale(1)',
  },
}));

export const TableHeadCustomStyle = {
  backgroundColor: 'black',
  borderCollapse: 'separate',
  '& th': {
    borderTop: '1px solid white',
    borderBottom: '1px solid white',
    color: 'white',
  },
  '& th:first-of-type': {
    paddingLeft: 2,
    borderLeft: '1px solid white',
    borderTop: '1px solid white',
    borderBottom: '1px solid white',
  },
  '& th:last-of-type': {
    paddingRight: 2,
    borderRight: '1px solid white',
    borderTop: '1px solid white',
    borderBottom: '1px solid white',
  },
};
